<template>
  <div class="shoot-data-info-container">
    <div class="shoot-data-info-map" ref="mapRef"
      @click.stop
      v-if="mapShowFlag"
    ></div>
    <div class="shoot-data-info-AI">
      <AIContent
        :url="queryLocationByQuestion()"
        :headers="{}"
        :data="layerGeojson"
      ></AIContent>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import * as turf from '@turf/turf';
import mapbox from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import AIContent from './AIContent';

import {
  getAirBaseByRegion, analyzeRegionByLlmURL, queryLocationByQuestion,
} from '@/api/Region';

// props
const props = defineProps({
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    // mapInit();
    getAirBaseByRegionFn(props.target);
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

const homeMap = computed(()=> store.getters['getHomeMap'] ),
      Lmap = toRaw(homeMap.value);

const polygonStyle = store.getters['leafletPolygon/polygonStyle'];

const layerProp = 'layer',
      layerGeojson = computed(()=>{
        const layer  = props.target[layerProp];
        return layer.toGeoJSON();
      })

const mapShowFlag = ref(false);
const getAirBaseByRegionFn = (item)=>{
  const mapDom = Lmap.getContainer();
  const geojson = item[layerProp],
        bounds = geojson.getBounds(),
        bbox = [
          bounds.getNorthWest().lng,
          bounds.getNorthWest().lat,
          bounds.getSouthEast().lng,
          bounds.getSouthEast().lat,
        ],
        geojsonStr = geojson.toGeoJSON(),
        geometry = JSON.stringify(geojsonStr['geometry']?geojsonStr['geometry']:geojsonStr);
  getAirBaseByRegion({
    bbox, geometry
  }).then(res=>{
    if(res.data.code == 1004){
      if(res.data.array.length == 0){
        // message('无数据', 2);
      }else{
        mapShowFlag.value = true;
        nextTick(()=>{
          mapInit(res.data.array);
        })
      }
    }
  }).catch(err=>{
    console.log(err);
  });
}

const mapRef = ref();

var mapBoxToken = store.getters.getMapBoxToken;
mapbox.accessToken = mapBoxToken;
let map;
const mapInit = (data)=>{
  map = new mapbox.Map({
    container: mapRef.value,
    center: [34.3227, 88.5525],
    zoom: 0,
    style: 'mapbox://styles/mapbox/satellite-streets-v12',
    language: 'zh-CN'
  });
  map.on('load', ()=>{
    mapDataInit(data);
  })
},
mapDataInit = (data)=>{
  const dataListStr = {
    type: 'FeatureCollection',
    features: data.map((base)=>{
      return {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [base.roiLonMin, base.roiLatMin], // 左下角
              [base.roiLonMax, base.roiLatMin], // 右下角
              [base.roiLonMax, base.roiLatMax], // 右上角
              [base.roiLonMin, base.roiLatMax], // 左上角
              [base.roiLonMin, base.roiLatMin] // 闭合到起点
            ]
          ]
        },
        properties: base,
      }
    })
  }

  map.addSource('area-data', {
    type: 'geojson',
    data: dataListStr
  });
  
  // 添加3D填充挤压图层
  map.addLayer({
    id: 'fill-polygon',
    type: 'fill',
    source: 'area-data',
    paint: {
      'fill-color': polygonStyle.color,
      'fill-opacity': 0,
    },
    'filter': ['==', '$type', 'Polygon']
  });
  map.addLayer({
    id: 'fill-line',
    type: 'line', // 使用线图层
    source: 'area-data', // 指向同一个数据源
    paint: {
      'line-color': polygonStyle.color,
      'line-width': 3 // 可以自由设置宽度
    }
  });
  const bbox = turf.bbox(dataListStr);
  const bounds = [[bbox[0], bbox[1]], [bbox[2], bbox[3]]];

  // 使用 bounds，例如调整地图视野
  map.fitBounds && map.fitBounds(bounds, {
    // padding: 30,
    duration: 1000,
    maxZoom: 10,
  });
  // map.once('moveend', () => {
  //   const camera = map.getFreeCameraOptions();
  //   camera.setPitchBearing(45, 0);
  //   map.setFreeCameraOptions(camera);
  // });

}

</script>

<style lang='less'>
/* 隐藏左下角的Logo（如果Logo在左下角） */
.mapboxgl-ctrl-logo { display: none !important; }

/* 或者隐藏右下角的 attribution 信息[citation:2] */
.mapboxgl-ctrl-attrib { display: none !important; }
</style>

<style lang='less' scoped>
.shoot-data-info-container{
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--padDefaultSize_2);
  .shoot-data-info-map{
    height: 300px;
  }
}
</style>